import {
  AddVehicleCoverage,
  AddVehicleTerm,
  typeOfAgentEmail,
  vehicleCAPartnerUse,
  vehicleOwnershipDate,
  vehiclePartnerUse,
  vehiclePrimaryUse
} from '@amfam/policy/add-vehicle/data-access';
import { Agent } from '@amfam/shared/utility/agent';

export interface VehicleInfo {
  primaryVehicleInfo: {
    vin: string;
    year: string;
    odoMeter: string;
  };

  currentPolicyNumber?: string;

  isNewVehicleDiscountActive?: boolean;

  primaryUsageInfo?: PrimaryUsageInfo;

  garageAddress?: string;

  leaseStartDate?: string;

  vehicleFeatures?: VehicleFeaturesInfoModel;

  underwritingQuestions?:
    | VehicleUnderwritingQuestionsModels
    | VehicleUnderwritingPartnerQuestionsModels;

  tpiInfo?: TPIModel;

  driverAssignment?: DriverInfoModel[];

  vehicleCoverages?: AddVehicleCoverage[];

  typeOfAgentEmail?: typeOfAgentEmail;

  selectedAgent?: Agent;

  workOrderNumber?: string;

  exitFlow?: boolean;
  //used for make/model/series if anyone of them are other or msrp is null
  otherExitFlow?: boolean;

  extendedGracePeriodStates?: string[];

  navigateToFuturePaymentSchedule?: boolean;
}

export interface PrimaryUsageInfo {
  primaryUse: vehiclePrimaryUse | vehiclePartnerUse | vehicleCAPartnerUse | vehicleOwnershipDate;
  mileage: string;
  ownershipDateVal: string;
  ownershipDateKey: string;
}

export interface VehicleFeaturesInfoModel {
  antiLockBreaks: boolean;
  dayTimeRunningLight: boolean;
  airBagsIndicator?: 'front' | 'Both' | 'none' | 'other';
  antiTheftDeviceIndicator: 'active' | 'passive' | 'none' | 'other';
  electronicStabilityControl: boolean;
  needAgent: boolean;
  kitCarOrReplica: boolean;
  antiTheftCategoryOne?: boolean;
  antiTheftCategoryTwo?: boolean;
  antiTheftCategoryThree?: boolean;
  antiTheftCategoryFour?: boolean;
}

export interface VehicleUnderwritingQuestionsModels {
  kitCarReplica?: boolean;
  hasOtherOrCoowner?: boolean;
  usedForBusiness?: boolean;
  noneOfThese?: boolean;
  hasLoanOrLease: boolean;
  unrepairedDamage?: boolean;
}

export interface VehicleUnderwritingPartnerQuestionsModels {
  kitCarReplica: boolean;
  hasOtherOrCoowner: boolean;
  usedForBusiness: boolean;
  noneOfThese: boolean;
  hasLoanOrLease?: boolean;
  hasLoan: boolean;
  hasLease: boolean;
  isDamaged: boolean;
}

export interface TPIInfoModel {
  hasTPI: boolean;
  tpis: TPIModel[];
}
export interface TPIModel {
  name: string;
  publicId: string;
}

export interface DriverInfoModel {
  vin: string;
  primary: boolean;
  publicId: string;
  name: string;
  vehicleId?: string;
  driverId?: string;
}
export interface CoverageDescriptionModel {
  description: string;
  subHeading: string;
  kydPackageDefaultSelectedoption?: string;
  isCheckBox: boolean;
  coverageHelpText: string;
  eligibleStates: string[];
  terms: AddVehicleTerm[];
}

export interface CoverageDescriptionModelForPartnerSpecific {
  description: StateWiseDescription;
  subHeading: string;
  isCheckBox: boolean;
  eligibleStates?: string[];
  inEligibleStates?: string[];
  terms: AddVehicleTerm[];
  kydPackageDefaultSelectedoption?: string;
}

export interface StateWiseDescription {
  [key: string]: string;
}

export enum vehicleCoverageSelectionOptions {
  Yes = 'Yes',
  Rejected = 'Rejected',
  NotProvided = 'Not Provided',
  NotApplicable = 'N/A'
}
